const ClipboardJS = require('clipboard');
const { default: toaster } = require('./toaster');

function init() {

	const buttons = document.querySelectorAll('.js-clipboard-button');

	// set up the clipboard functionality for this button
	buttons.forEach(el => {
		const instance = new ClipboardJS(el);
		instance.on('success', () => {
			toaster.show('URL copied to clipboard!');
		});
	});
	
}

export default init;